import { render, staticRenderFns } from "./BeatLoader.vue?vue&type=template&id=ae47d344&"
import script from "./BeatLoader.vue?vue&type=script&lang=js&"
export * from "./BeatLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports